function AutoTabs() {
}

AutoTabs.prototype = {
    init: function () {
        'use strict';

        $('.jTabs').each(function () {
            var $container = $(this);

            // Tabs and content blocks
            var $tabs = $container.find('li');
            var $contentGroup = $container.data('contentgroup');
            var $tabContentBlocks = $("[id^=content_]" + (!$contentGroup ? "" : ".contentGroup_" + $contentGroup));

            if ($tabs.length) {

                $('#tabs .ui-tabs-nav').css('border-bottom', '1px solid #999');

                //If hidden initially - show it
                $container.removeClass('hidden-element').show();
                $('#productDetailsTabs').removeClass('hidden-element').show();

                // Initial tab activation
                var $activeTab = $tabs.filter('.active');
                if (window.location.hash) {
                    try {
                        var preselectedTab = $container.find('.' + window.location.hash.substring(1));
                        if (preselectedTab.length) {
                            $activeTab = preselectedTab;
                            if (IsMobile.any()) {
                                $(document).scrollTop($activeTab.offset().top);
                            }
                        }
                    } catch (e) {
                    }
                }

                $tabs.removeClass("active");
                // Activation on click
                $tabs.on('click', function () {
                    AutoTabs.prototype.clickEvent($container, $(this));
                });

                if (!$activeTab.length) {
                    $activeTab = $($tabs[0]);
                    if (!$tabContentBlocks.hasClass("non-initial")) {
                        $activeTab.trigger("click");
                    }
                } else {
                    $activeTab.trigger("click");
                }
            }

        });
    },

    clickEvent: function ($container, $tab) {
        if (!$tab.length) {
            return;
        }

        // Tabs and content blocks
        var $tabs = $container.find('li');
        var $contentGroup = $container.data('contentgroup');
        var $tabContentBlocks = $("[id^=content_]" + (!$contentGroup ? "" : ".contentGroup_" + $contentGroup));
        var $tabContent = $('#content_' + $tab.data('link'));

        var $tabTable = $('.tab-table');
        if ($tabTable.length) {
            $tabTable.hide();
        }

        $tabs.removeClass("active");
        $tabContentBlocks.removeClass("active").hide();

        $tab.addClass('active');
        $tabContent
            .removeClass('hidden-element')
            .addClass('active')
            .fadeIn();
    }

};

(function init(namespace) {
    'use strict';

    namespace.autoTabs = new AutoTabs();

    $($.proxy(namespace.autoTabs.init, namespace.autoTabs));

})(THEME);


function activateTab(tabName) {
    //find tab and tab content to be activated
    var $tab = $("ul").find("[data-link='" + tabName + "']");
    var $container = $tab.closest('.jTabs');

    AutoTabs.prototype.clickEvent($container, $tab);
}